export class FooterConstants {
  public static readonly CHOOSE_BUTTON_CLASS_NAME = 'choose-button';
}
